import {handleApiErrorResponse} from "../lib/helpers";

export function getLanguagesService(){
    return fetch(process.env.REACT_APP_API_END_POINT+'languages/list', {
        method: 'GET',
        headers:{"Content-Type":"application/json","Accept":"application/json"}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}